import { Injectable } from '@angular/core';
import { UrlTree } from '@angular/router';
import { NavController } from '@ionic/angular';
import { DataCentralService } from '@shared/providers/core/data-central.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  constructor(private dataCentralService: DataCentralService, private navCtrl: NavController) {}

  public canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkSession();
  }

  public canActivateChild(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkSession();
  }

  /** Verifica si la sesion expiro o si no hay usuario registrado */
  private checkSession(): boolean {
    const sessionExpiry = this.dataCentralService.sessionExpires ?? 0;
    const now = Date.now();
    const user = this.dataCentralService.user;
    const hasUser = user && Object.keys(user).length > 0;
    if (hasUser) {
      const sessionExpired = now > sessionExpiry;
      if (sessionExpired) {
        this.navCtrl.navigateRoot('/login/expired');
        this.dataCentralService.clearSession();
      }
      return !sessionExpired;
    }
    this.navCtrl.navigateRoot('/login');
    return false;
  }
}
